import { CashManagementTransactionType } from './CashManagementTransactionType';
import {
  IsArray,
  IsBoolean,
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';

export class PostCashManagementDto {
  @IsOptional()
  @IsArray()
  @IsInt({ each: true })
  coins?: number[];
  @IsOptional()
  @IsInt()
  bankAccountAmount?: number;
  @IsOptional()
  @IsInt()
  immediateFeeAmount?: number;
  @IsOptional()
  @IsBoolean()
  immediateFeeTracked?: boolean;
  @IsOptional()
  @IsInt()
  separateFeeAmount?: number;
  @IsOptional()
  @IsNumber()
  separateFeePercentage?: number;
  @IsOptional()
  @IsUUID(4)
  resident_id?: string;
  @IsEnum(CashManagementTransactionType)
  type!: CashManagementTransactionType;
  @IsOptional()
  @IsString()
  notes?: string;
  @IsNotEmpty()
  @IsUUID(4)
  cashListId!: string;
}
